import React from 'react';
import { Container, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import { NavEvent, navEventFromString } from '../nav/NavEvent';


interface OffScreenNavBarProps {
  onSelect: (event: NavEvent) => void;
}

export function OffScreenNavBar(props: OffScreenNavBarProps) {
  const expand = false;

  function onSelect(eventKey: string | null) {
    console.log(`OffScreenNavBar.onSelect ${eventKey}`);
    if (eventKey) {
      props.onSelect(navEventFromString(eventKey));
    }
  }

  return <Navbar bg='dark' variant='dark' expand={expand} collapseOnSelect={true} sticky='top' fixed='top'>
    <Container fluid>
      <Navbar.Brand>Sailing Handicap Calculator</Navbar.Brand>
      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
      <Navbar.Offcanvas placement="end" >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Sailing Handicap Calculator</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav variant="pills" onSelect={onSelect}>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.GROUPS}>Groups</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.BOATS}>Boats</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.TABLE}>Table</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.EXPORT}>Export</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.IMPORT}>Import</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={NavEvent.ABOUT}>About</Nav.Link>
            </Nav.Item>
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Container>
  </Navbar>;
}
